import Vue from "vue";
import VueRouter from "vue-router";

import YOURentLocator from "@Scripts/Components/YOURent/Locator.vue";
import YOURentDealerPointDetail from "@Scripts/Components/YOURent/DealerPointDetail.vue";

import JobOfferDetail from "@Scripts/Components/WorkWithUs/JobOfferDetail.vue";
import JobProfileSubmit from "@Scripts/Components/WorkWithUs/JobProfileSubmit.vue";
import WorkWithUsLocator from "@Scripts/Components/WorkWithUs/WorkWithUsLocator.vue";

Vue.use(VueRouter);

export const router = new VueRouter({
    mode: "history",
    routes: [
        {
            name: "Locator", path: "/noleggio/:language", component: YOURentLocator, props: true,
            children: [
                {
                    name: "DealerPointDetail", path: "/noleggio/:language/:dealerPointCode", component: YOURentDealerPointDetail, props: true
                }
            ]
        },
        {
            name: "WorkWithUsLocator", path: "/lavora-con-noi", component: WorkWithUsLocator, props: true,
            children: [
                {
                    name: "JobFreeProfileSubmit", path: "/lavora-con-noi/candidatura-spontanea", component: JobProfileSubmit, props: true
                },
                {
                    name: "JobOfferDetail", path: "/lavora-con-noi/:offerIdMaster", component: JobOfferDetail, props: true,
                    children: [
                        {
                            name: "JobProfileSubmit", path: "/lavora-con-noi/:offerIdMaster/candidati", component: JobProfileSubmit, props: true
                        }
                    ]
                }
            ]
        }
    ]
});